import { Image } from 'react-datocms';

import { Heading } from '@/components/heading';
import { Link } from '@/components/link';
import { Text } from '@/components/text';
import { PostInterface } from '@/types/cms-types';
import { tv } from '@/utils/styles';

export interface AuthorProps {
  author: PostInterface['author'];
}

const Author = ({ author }: AuthorProps) => {
  const { shortBio, linkedIn, twitter } = author;

  const { base, header, headerInner, image, link, bio, heading, authorPreText, socials } = styles();

  return (
    <article className={base()}>
      <header className={header()}>
        <Heading as="h2" variant="h3" className={authorPreText()}>
          Written By
        </Heading>
        <div className={headerInner()}>
          <Image data={author.image.responsiveImage} className={image()} />
          <div>
            <Heading as="h2" className={heading()}>
              {author.name}
            </Heading>
            <Text className="mb-0 text-blue-500" variant="baseLg">
              {author.jobTitle}
            </Text>
            <Text className="mb-0 text-blue-500" variant="baseLg">
              Fluent Cargo
            </Text>
          </div>
        </div>
      </header>

      {/* eslint-disable-next-line react/no-danger */}
      <div className={bio()} dangerouslySetInnerHTML={{ __html: shortBio }} />
      {(linkedIn || twitter) && (
        <ul className={socials()}>
          {linkedIn && (
            <li>
              <Link href={linkedIn} target="_blank" rel="noopener noreferrer" className={link()}>
                LinkedIn
              </Link>
            </li>
          )}
          {twitter && (
            <li className="ml-4">
              <Link href={twitter} target="_blank" rel="noopener noreferrer" className={link()}>
                Twitter
              </Link>
            </li>
          )}
        </ul>
      )}
    </article>
  );
};

const styles = tv({
  slots: {
    base: 'mb-8 rounded-md bg-brandSoftBlue p-4 md:p-8 lg:mx-auto',
    bio: 'mt-4 text-blue-500 [&_p]:last-of-type:mb-0',
    header: 'flex flex-col',
    headerInner: 'max-xl:flex max-xl:items-center',
    heading: 'mb-0 !text-baseLg font-semibold text-blue-500',
    authorPreText: '!text-base uppercase text-lightBlue-500',
    image: 'mb-4 mr-6 !size-20 rounded-full',
    link: 'text-baseSm font-medium text-lightBlue-600 no-underline hover:underline',
    socials: 'mt-4 flex',
  },
});

export { Author };
